export const createDate = (rawData: string) => {
  const data = rawData.replace(/(\d+[/])(\d+[/])/, '$2$1');
  const timestamp = Date.parse(data);
  if (isNaN(timestamp)) throw new Error('Format de Data incorrecte MM/DD/YYYY');
  const new_data = new Date(timestamp);
  return new_data;
};
